import { fetchApi } from '@/services/api-client';

export const SITE_SETTINGS_PATH = '/admin/site-settings';

export const siteSettingsApi = {
  getAll: () => fetchApi<Record<string, unknown>>(SITE_SETTINGS_PATH),
  update: (key: string, value: unknown) =>
    fetchApi<{ success: boolean }>(`${SITE_SETTINGS_PATH}/${key}`, {
      method: 'PUT',
      body: JSON.stringify({ value }),
    }),
};
